/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AlbumSong
 */
export interface AlbumSong {
    /**
     * 
     * @type {string}
     * @memberof AlbumSong
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AlbumSong
     */
    songId: string;
    /**
     * 
     * @type {string}
     * @memberof AlbumSong
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AlbumSong
     */
    artist: string;
    /**
     * 
     * @type {string}
     * @memberof AlbumSong
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof AlbumSong
     */
    remark: string;
}

/**
 * Check if a given object implements the AlbumSong interface.
 */
export function instanceOfAlbumSong(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "songId" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "artist" in value;
    isInstance = isInstance && "remark" in value;

    return isInstance;
}

export function AlbumSongFromJSON(json: any): AlbumSong {
    return AlbumSongFromJSONTyped(json, false);
}

export function AlbumSongFromJSONTyped(json: any, ignoreDiscriminator: boolean): AlbumSong {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'songId': json['songId'],
        'name': json['name'],
        'artist': json['artist'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'remark': json['remark'],
    };
}

export function AlbumSongToJSON(value?: AlbumSong | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'songId': value.songId,
        'name': value.name,
        'artist': value.artist,
        'url': value.url,
        'remark': value.remark,
    };
}

